<template style="background-color: transparent; position:relative;">
	<StaticViewComponent :content="content"></StaticViewComponent>
</template>

<script>

import StaticViewComponent from "@/components/StaticViewComponent";

export default {
	props: {},
	components: {
		StaticViewComponent,
	},
	metaInfo: {
		title: 'Политика использования файлов куки',
		meta: [
			{name: 'theme-color', content: '#161616'},
			{name: 'apple-mobile-web-app-capable', content: 'yes'},
			{name: 'apple-mobile-web-app-status-bar-style', content: 'yes'},
			// <meta name="apple-mobile-web-app-capable" content="yes">
			// <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent">
			// {vmid: 'description', property: 'description', content: 'Vue App'},
			// {vmid: 'og:title', property: 'og:title', content: 'Vue App'},
			// {vmid: 'og:description', property: 'og:description', content: 'Vue App'},
		],
	},
	data() {
		return {
			content: `
			<p><strong>Политика использования файлов куки (cookies)</strong></p>

			<p>Настоящая политика использования файлов куки (cookies) утверждена Обществом с ограниченной ответственностью &laquo;Интерсоюз&raquo; ( ОГРН 1077627003332 &nbsp; ИНН 7627031770, адрес: Ярославская область, Ярославский район, п.Дубки, ул.Школьная, д.1), в целях установления порядка использования файлов куки на сайте www.dolphin-hotel.ru</p>

			<p><strong>Что такое файлы куки (cookies)?</strong></p>

			<p>Файлы куки (cookies) &mdash; это текстовые файлы небольшого объема, сохраняемые веб-сайтом на Вашем пользовательском устройстве (компьютере, планшете или мобильном телефоне); они НЕ являются вредоносными для Вашего устройства или безопасности. При посещении Вами веб-сайта файлы куки позволяют веб-сайту &laquo;запоминать&raquo; Вас для повышения качества взаимодействия с сайтом.</p>

			<p>Более подробную информацию о файлах куки можно найти в Интернете или пройдя по ссылке
			<a target="_blank" href="http://www.aboutcookies.org.">http://www.aboutcookies.org</a>.
			</p>

			<p>&nbsp;</p>

			<p><strong>Как вы можете контролировать настройки, позволяющие использование файлов куки?</strong></p>

			<p>В большинстве случаев программное обеспечение для просмотра веб-сайтов &ndash; веб-браузер (в т.ч. Chrome, Internet Explorer, Firefox, Safari), по умолчанию допускает хранение файлов куки в устройстве пользователя.</p>

			<p>Если Вы не хотите получать файлы куки, Вы можете изменить настройки веб-браузера так, чтобы он уведомлял Вас о получении этих файлов, изменить настройки их работы или же полностью отказаться от них, выбрав соответствующие настойки веб-браузера. Вы также можете удалить уже сохраненные файлы куки.</p>

			<p>Подробная информация о возможности и способах передачи файлов куки доступна в настройках веб-браузера.</p>

			<p>Однако обращаем Ваше внимание на то, что если Вы решите отказаться от наших файлов куки, возможно, Вы не сможете использовать функции нашего сайта в полном объеме.</p>

			<p><strong>Каким образом собирается и используется другая информация?</strong></p>

			<p>Мы можем использовать файлы cookie в различных целях, в том числе, чтобы:</p>

			<p>получать информацию о ваших посещениях сайта;</p>

			<p>обрабатывать ваши заказы;</p>

			<p>анализировать информацию о вашем посещении страниц для совершенствования нашего сайта;</p>

			<p>предоставлять рекламу, сообщения и контент, созданные нами и третьими лицами, учитывая ваши интересы;</p>

			<p>помогать вам в получении необходимой информации;</p>

			<p>определять количество посетителей и то, как они используют наш сайт, &mdash; для повышения эффективности работы сайта и для наилучшего понимания интересов его аудитории.</p>

			<p>Файлы куки собирают статистическую информацию, которую мы используем только для указанных выше целей; пользователи остаются анонимным.</p>

			<p><strong>Как долго файлы cookie хранятся на моем устройстве?</strong></p>

			<p>Некоторые файлы cookie действуют с момента вашего входа на сайт до конца данной конкретной сессии работы в браузере. При закрытии браузера эти файлы становятся ненужными и автоматически удаляются. Такие файлы cookie называются &laquo;сеансовыми&raquo;.</p>

			<p>Некоторые файлы cookie сохраняются на устройстве и в промежутке между сессиями работы в браузере &mdash; они не удаляются после закрытия браузера. Такие файлы cookie называются &laquo;постоянными&raquo;. Срок хранения постоянных файлов cookie на устройстве различается для разных файлов cookie. Мы используем постоянные файлы cookie в различных целях: например, чтобы точнее определить, как часто вы посещаете наш сайт или как часто вы на него возвращаетесь, как с течением времени меняется характер использования нашего сайта, а также для оценки эффективности рекламы. Постоянные файлы cookie автоматически будут удалены с вашего устройства после достижения их цели.</p>

			<p><strong>Кто размещает файлы cookie на моем устройстве?</strong></p>

			<p>Файлы cookie могут размещаться на вашем устройстве администрацией сайта dolphin-hotel.ru. Эти файлы cookie называются &laquo;собственными&raquo;.</p>

			<p>Мы можем использовать файлы cookie, чтобы узнать, когда вы посещаете наш сайт, как взаимодействуете рекламой и другим контентом. На основе файлов cookie может собираться и использоваться обобщенная и другая информация, не связанная с идентификацией отдельных пользователей (например, об операционной системе, версии браузера и URL-адресе, с которого выполнен переход на данную страницу, в том числе из электронного письма или рекламного объявления) &mdash; благодаря этому мы можем предоставить вам более широкие возможности и проанализировать маршруты посещения сайта. Такая технология позволяет подсчитать количество пользователей, которые посетили конкретный сервис, перейдя по ссылке с определенного баннера за пределами данного сайта, по текстовой ссылке или изображениям, включенным в рассылку. Кроме того, она служит инструментом для сбора обобщенной статистики об использовании сайта в целях аналитического исследования и помогает нам оптимизировать наш сайт, предлагать рекламу в соответствии с вашими интересами, как подробно описано ниже.</p>

			<p>На нашем сайте размещаются специальные технологии аналитических веб-служб (например, Яндекс.Метрика), подсчитывающие количество посетителей и оценивающие показатели использования и эффективность использования сайта. Получаемые таким образом данные анонимны и не содержат идентифицирующую вас информацию (не устанавливают вашу личность). Информация используется исключительно в статистических целях.</p>

			<p>Чтобы узнать, как использует файлы cookie сервис Яндекс.Метрика, ознакомьтесь с условиями его использования*. Также мы приводим ссылки для отказа от использования аналитических сервисов Яндекс.Метрика (если вы считаете, что они вам не нужны)**.</p>

			<p>*Условия использования сервиса Яндекс.Метрика: <a target="_blank" href="https://yandex.ru/legal/metrica_termsofuse/">https://yandex.ru/legal/metrica_termsofuse/</a></p>

			<p>**Отказаться от использования аналитических сервисов Яндекс.Метрика вы можете, загрузив и установив дополнительные инструменты: <a target="_blank" href="https://yandex.ru/support/metrica/general/opt-out.html">https://yandex.ru/support/metrica/general/opt-out.html</a></p>

			<p>Ваши персональные данные (ФИО, контактные данные, т.д.) собираются только с Вашего согласия - при заполнении Вами одной из контактных форм, доступных на нашем сайте. Обработка персональных данных пользователей нашего сайта осуществляется в строгом соответствии с Федеральным законом от 27.07.2006 года №152-ФЗ &laquo;О персональных данных&raquo; в соответствии с Политикой конфиденциальности.</p>
			`,
		};
	},	// mounted() {
	// 	this.$refs.goToTopAnchor.click()
	// },
	methods: {}
};
</script>

<style scoped>
</style>
